import React from 'react'

import { Box, Grid } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'

const EmailStepSkeleton = () => (
  <Grid container spacing={6} justifyContent="center">
    <Grid item xs={12} md={8}>
      <Box display="flex" justifyContent="center">
        <Skeleton variant="text" width="60%" height={48} />
      </Box>
    </Grid>
    <Grid item xs={12} md={8}>
      <Box display="flex" justifyContent="center">
        <Skeleton variant="text" width="80%" height={32} />
      </Box>
    </Grid>
    <Grid item xs={12}>
      <Grid container spacing={4} justifyContent="center">
        <Grid item xs={12} md={8}>
          <Skeleton variant="rect" width="100%" height={56} />
        </Grid>
      </Grid>
    </Grid>
  </Grid>
)

export default EmailStepSkeleton
